import React from "react";
import { withView, ViewComponentProps } from "../../shared/viewcomponent";

export const TestComponent = withView((props: ViewComponentProps) => {

    return <></>
});